const styles = (theme) => ({
  cardHeader: {
    alignItems: 'space-between',
    paddingBottom: 0,
  },
  cardTitleDescription: {
    marginBottom: theme.spacing.unit,
  },
  cardContent: {
    padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${
      theme.spacing.unit * 2
    }px`,
    marginTop: theme.spacing.unit,
  },
  gridItemDivider: {
    '&&': {
      paddingTop: 0,
      paddingBottom: theme.spacing.unit / 2,
    },
  },
  headerContent: {
    alignSelf: 'flex-end',
  },
  avatar: {
    background: theme.palette.background.lighter,
    color: theme.palette.text.white,
    marginTop: -theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit / 2,
    border: 'none',
    width: 70,
    height: 80,
    marginTop: '10px',
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  calendarTop: {
    height: 20,
    background: theme.palette.custom.details,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    borderRadius: '3px 3px 0 0',
    borderColor: theme.palette.custom.details,
    borderStyle: 'solid',
    borderWidth: '2px',
    [theme.breakpoints.up('md')]: {
      height: 20,
    },
  },
  calendarBottom: {
    height: 60,
    borderRadius: '0 0 3px 3px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: theme.palette.border.lighter,
  },
  dayName: {
    color: theme.palette.text.white,
    textAlign: 'center',
    fontSize: '0.875rem',
  },
  day: {
    textAlign: 'center',
    fontSize: '1.625rem',
    fontWeight: 600,
  },
  monthYear: {
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '0.875rem',
  },
  timeContainer: {
    '&&': {
      paddingTop: theme.spacing.unit * 1.5,
    },
  },
  fieldIcon: {
    color: theme.palette.custom.appointments,
  },
  subtitle: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 1.5,
  },
  fieldTitle: {
    fontSize: '1rem',
    color: '#666666',
    marginBottom: 5,
    lineHeight: '1rem',
  },
  fieldValue: {
    fontSize: '1.125rem',
  },
});

export default styles;
